export const checkBrowser = () => {
    const isOpera = !!window['opera'] || window.navigator.userAgent.indexOf(' OPR/') >= 0;
    return {
        isChrome: !!window['chrome'] && !isOpera,
        isEdge: /Edge\/\d+/.test(window.navigator.userAgent),
        isFirefox: typeof window['InstallTrigger'] !== 'undefined',
        isIE: !!document['documentMode'], // At least IE6
        isOpera: isOpera,
        isSafari: navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1,
        isIPhone: navigator.userAgent.indexOf('iPhone') !== -1,
        isAndroid: /Android/i.test(navigator.userAgent),
    };
};
export const redirect = (redirectUrl) => {
    window.location.replace(redirectUrl);
};
export const refreshPage = () => {
    window.location.reload();
};
